<template>
  <div>
    <b-card
      :img-src="resource.url"
      class="mb-2 resource-card card-img-top"
      img-alt="Image"
      img-top
      no-body
      style="max-width: 20rem;"
      tag="div"
      v-if="resource.mediaType === 'Image' && resource.url">
      <b-card-body>
        <b-card-title>
          <router-link :title="getTitle"
                       :to="{ name: 'resourceView', params: { id: resource.id }}"
                       class="text-blue card-text"
                       v-b-tooltip.hover.bottom>{{ getTitle | truncate(55, '...') }}
          </router-link>
        </b-card-title>
      </b-card-body>
      <b-card-footer class="bg-white" v-if="isEditable || isDeletable || isShareable">
        <router-link :to="{ name: 'resourceEdit', params: { id: resource.id } }" class="text-dark mr-1"
                     title="Edit your ingredient" v-b-tooltip.hover.bottom v-if="isEditable">
          <font-awesome-icon icon="edit"/>
          Edit
        </router-link>
        <b-link @click.prevent="showMsgDelete(resource.id, resource.title)" class="text-dark mr-1"
                title="Delete your resource"
                v-b-tooltip.hover.bottom v-if="isDeletable">
          <font-awesome-icon icon="trash-alt"/>
          Delete
        </b-link>
        <b-link @click.prevent="shareResource(resource.id)" class="text-dark" title="Share your ingredient" to="#"
                v-b-tooltip.hover.bottomright v-if="isShareable">
          <font-awesome-icon icon="share"/>
          Share
        </b-link>
      </b-card-footer>
    </b-card>

    <b-card
      class="mb-2 resource-card card-img-top"
      img-alt="Image"
      img-top
      no-body
      style="max-width: 20rem;"
      tag="div"
      v-if="resource.mediaType === 'Image' && !resource.url"
    >
      <div class="bg-gray p-5 m-0 banner-fill">
      <span :style="adjustColor(resource.mediaType)" class="pl-4">
        <font-awesome-icon :icon="adjustIcon(resource.mediaType)"
                           class="ml-3"
                           size="5x">
        </font-awesome-icon>
      </span>
      </div>
      <b-card-body>
        <b-card-title>
          <router-link :to="{ name: 'resourceView', params: { id: resource.id }}" class="text-blue card-text"
                       title="View more"
                       v-b-tooltip.hover.bottom>{{ getTitle | truncate(55, '...') }}
          </router-link>
        </b-card-title>
      </b-card-body>
      <b-card-footer class="bg-white" v-if="isEditable || isDeletable || isShareable">
        <router-link :to="{ name: 'resourceEdit', params: { id: resource.id } }" class="text-dark mr-1"
                     title="Edit your resource" v-b-tooltip.hover.bottom v-if="isEditable">
          <font-awesome-icon icon="edit"/>
          Edit
        </router-link>
        <b-link @click.prevent="showMsgDelete(resource.id, resource.title)" class="text-dark mr-1"
                title="Delete your resource"
                v-b-tooltip.hover.bottom v-if="isDeletable">
          <font-awesome-icon icon="trash-alt"/>
          Delete
        </b-link>
        <b-link @click.prevent="shareResource(resource.id)" class="text-dark" title="Share your resource" to="#"
                v-b-tooltip.hover.bottomright v-if="isShareable">
          <font-awesome-icon icon="share"/>
          Share
        </b-link>
      </b-card-footer>
    </b-card>

    <b-card
      class="mb-2 resource-card card-img-top"
      img-alt="Image"
      img-top
      no-body
      style="max-width: 20rem;"
      tag="div"
      v-if="resource.mediaType !== 'Image'">
      <div class="bg-gray p-5 m-0 banner-fill">
        <span :style="adjustColor(resource.mediaType)" class="pl-4">
          <font-awesome-icon
            :icon="adjustIcon(resource.mediaType)"
            class="ml-4"
            size="5x">
          </font-awesome-icon>
        </span>
      </div>
      <b-card-body>
        <b-card-title>
          <router-link :title="getTitle"
                       :to="{ name: 'resourceView', params: { id: resource.id } }"
                       class="text-blue card-text"
                       v-b-tooltip.hover.bottom>{{ getTitle | truncate(55, '...') }}
          </router-link>
        </b-card-title>
      </b-card-body>
      <b-card-footer class="bg-white" v-if="isEditable || isDeletable || isShareable">
        <router-link :to="{ name: 'resourceEdit', params: { id: resource.id } }" class="text-dark mr-1"
                     title="Edit your resource" v-b-tooltip.hover.bottom v-if="isEditable">
          <font-awesome-icon icon="edit"/>
          Edit
        </router-link>
        <b-link @click.prevent="showMsgDelete(resource.id, resource.title)" class="text-dark mr-1"
                title="Delete your ingredient"
                v-b-tooltip.hover.bottom v-if="isDeletable">
          <font-awesome-icon icon="trash-alt"/>
          Delete
        </b-link>
        <b-link @click.prevent="shareResource(resource.id)" class="text-dark" title="Share your ingredient" to="#"
                v-b-tooltip.hover.bottomright v-if="isShareable">
          <font-awesome-icon icon="share"/>
          Share
        </b-link>
      </b-card-footer>
    </b-card>
  </div>
</template>

<script>
import {eventBus} from '../../main'

export default {
  name: 'resourceCard',
  props: {
    'resource': Object
  },
  computed: {
    isShared () {
      // check if the resource is shared
      if (this.resource.rights === 'READ' || this.resource.rights === 'WRITE') {
        return this.resource.isShared
      }
    },
    isEditable () {
      // check if edit action is allowed
      return this.resource.rights === 'OWN' || this.resource.rights === 'WRITE'
    },
    isDeletable () {
      // check if delete action is allowed
      return this.resource.rights === 'OWN'
    },
    isShareable () {
      // check if share action is allowed
      return this.resource.rights === 'OWN'
    },
    getTitle () {
      let title = this.resource.title
      if (title) {
        return title
      }
      return '<Untitled>'
    }
  },
  methods: {
    showMsgDelete (resId, resTitle) {
      this.boxTwo = ''
      this.$bvModal.msgBoxConfirm('Please confirm that you want to delete this resource.', {
        title: 'Are you sure you want to delete ' + resTitle + '?',
        size: 'bg',
        buttonSize: 'bg',
        okVariant: 'danger',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
        .then(value => {
          this.boxTwo = value
          if (this.boxTwo) {
            this.deleteResource(resId)
          } else {
          }
        })
        .catch(error => {
          alert('An error occurred! Please refresh the page.' + error)
        })
    },
    deleteResource (resourceId) {
      this.$store.dispatch('deleteResourceEntity', resourceId).then(
        data => {
          window.location.reload()
        })
    },
    shareResource (resourceId) {
      let b = [resourceId, this.resource.title]
      console.log(b)
      eventBus.$emit('shareResource', b)
    },
    adjustIcon (mediaType) {
      // load the proper icon given the media type
      if (mediaType === 'Image') {
        return 'image'
      } else if (mediaType === 'Audio') {
        return 'file-audio'
      } else if (mediaType === 'Video') {
        return 'play-circle'
      } else if (mediaType === 'Website') {
        return 'link'
      } else if (mediaType === 'Text') {
        return 'file-alt'
      } else if (mediaType === 'Pdf') {
        return 'file-pdf'
      } else {
        return 'file-alt'
      }
    },
    adjustColor (mediaType) {
      // load the proper icon given the media type
      if (mediaType === 'Image') {
        return 'image'
      } else if (mediaType === 'Audio') {
        return 'color: #f0d6f1'
      } else if (mediaType === 'Linked Video') {
        return 'color: #ff6c6c'
      } else if (mediaType === 'Website') {
        return 'color: #95c9ff'
      } else if (mediaType === 'Text') {
        return 'color: #fff37a'
      } else if (mediaType === 'Pdf') {
        return 'color: red'
      } else {
        return 'color: #fff37a'
      }
    }
  }
}
</script>

<style scoped>
  .resource-card {
    height: 320px !important;
  }

  .banner-fill {
    height: 165px !important;
    max-height: 165px !important;
    box-shadow: none !important;
  }

  .resource-card:hover {
    box-shadow: 2px 2px 2px 2px #bbbbbb;
  }

  .card-img-top {
    width: 100%;
    height: 180px;
    object-fit: cover;
  }

  .card-text {
    font-size: 20px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/resources/ResourceCard.vue